import React from 'react'

export function RowStrip(props){
    return(
        <div className="flex flex-row flex-wrap justify-evenly">
            {props.children}
        </div>
    )
}